<template>
    <div class="magazines">
        <div
            class="magazines-headers"
            v-if="archive === 0">
            <b-button
                class="btn-add btn-new-magazine"
                variant="primary"
                @click="showAddMagazine">
                {{ $t('magazine.new') }}
            </b-button>
            <b-button
                class="btn-box btn-archived-magazine"
                variant="primary"
                :href="routes.magazineArchive()">
                {{ $t('magazine.archive') }}
            </b-button>
        </div>

        <div class="apprentice-simple-card">
            <div class="row">
                <div
                    class="col-12 not-found with-header empty-magazine-list"
                    v-if="magazines.length === 0">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('magazine.no_books_and_or_magazines_found') }}</div>
                </div>

                <div
                    class="col-12 col-md-6 grid-margin stretch-card magazine-preview"
                    v-for="magazine in magazines"
                    v-else>
                    <div class="magazine">
                        <div
                            class="magazine-cover"
                            :class="
                                magazine.cover && magazine.cover.thumb === null ? 'btn-missing-image no-preview' : null
                            "
                            @click="onClick(magazine.id)">
                            <img
                                class="magazine-cover-thumb"
                                v-if="magazine.cover && magazine.cover.thumb !== null"
                                :src="magazine.cover.thumb" />
                        </div>

                        <div class="magazine-description">
                            <h4
                                class="title"
                                @click="onClick(magazine.id)">
                                {{ magazine.title }}
                            </h4>

                            <ul
                                class="list-unstyled magazine-summary"
                                @click="onClick(magazine.id)">
                                <li>
                                    <span class="label">{{ $t('magazine.edition') }}</span
                                    >{{ magazine.quantity }}
                                </li>
                                <li>
                                    <span class="label">{{ $t('magazine.format') }}:</span>{{ magazine.size.width }}mm x
                                    {{ magazine.size.height }}mm
                                </li>
                                <li>
                                    <span class="label">{{ $t('magazine.format_type') }}</span
                                    >{{ magazine.version }}
                                </li>
                                <li>
                                    <span class="label">{{ $t('magazine.pages') }}</span
                                    >{{ magazine.num_pages }}
                                </li>
                            </ul>

                            <div
                                class="magazine-actions"
                                v-if="isAdmin"
                                style="text-align: left">
                                <b-button
                                    class="btn-duplicate btn-copy-magazine"
                                    v-b-tooltip.hover
                                    v-b-modal="'copy-magazine-modal'"
                                    variant="primary-icon"
                                    :title="$t('common.copy')"
                                    @click="showCopyMagazine(magazine)">
                                </b-button>

                                <b-button
                                    class="btn-inbox-out btn-un-archived-magazine"
                                    v-b-tooltip.hover
                                    v-if="archive == 1"
                                    variant="primary-icon"
                                    :title="$t('magazine.remove_from_archive')"
                                    @click="moveOutArchive(magazine.id)">
                                </b-button>

                                <b-button
                                    class="btn-remove-fad btn-remove-magazine"
                                    v-b-tooltip.hover
                                    variant="danger-icon"
                                    :title="$t('common.delete')"
                                    @click="deleteMagazine(magazine.id)">
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <design-2021-copy-magazine-modal-component
            @copy-magazine="addMagazine($event)"
            ref="copy-magazine-modal">
        </design-2021-copy-magazine-modal-component>
        <design-2021-add-magazine-modal-component
            v-if="archive === 0"
            :sizes="sizes"
            ref="add-magazine-modal"
            @add-magazine="addMagazine($event)">
        </design-2021-add-magazine-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-overview-component',
    props: ['magazinesIn', 'sizes', 'isAdmin', 'archive'],
    data() {
        return {
            magazines: this.magazinesIn,
            laminationError: false,
        };
    },
    methods: {
        onClick(id) {
            location.href = this.routes.baseUrl() + '/magazine/' + id;
        },
        deleteMagazine(id) {
            this.alert
                .confirm(
                    this.$t('common.delete'),
                    this.$t('magazine.are_you_sure_you_want_to_delete_this_book_or_magazine'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.magazineDelete(id)).then(
                            (response) => {
                                this.alert.success();
                                for (let magazine of this.magazines) {
                                    if (magazine.id == id) {
                                        this.magazines.splice(this.magazines.indexOf(magazine), 1);
                                    }
                                }
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        moveOutArchive(id) {
            window.location.href = this.routes.magazineMoveOutArchive(id);
        },

        showAddMagazine() {
            this.$refs['add-magazine-modal'].show();
        },
        showCopyMagazine(magazine) {
            this.$refs['copy-magazine-modal'].show(magazine);
        },

        addMagazine(magazine) {
            this.magazines.unshift(magazine);
            this.alert.success();
            this.alert.success();
        },
    },
};
</script>

<style scoped lang="scss">
.magazines-headers {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-end;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .btn {
        width: 100%;

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.magazine-preview {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.magazine {
    display: flex;
    flex-direction: row;
    background-color: $white;
    border-radius: $border-radius-content;
    padding: map-get($grid-gutter-spacing, 'twenty-one');

    .magazine-cover {
        width: 40%;

        img {
            max-width: 100%;
            object-fit: cover;
            object-position: center;
            border-radius: $border-radius-content;
        }

        &.no-preview {
            background-color: $inverse-info;
            border-radius: $border-radius-content;

            &:before {
                font-size: 6rem;
                color: $white;
                opacity: 0.3;
                margin-right: 0;
            }

            &:after {
                content: '';
                padding-bottom: 139.5%;
            }
        }

        &:hover {
            cursor: pointer;
        }
    }

    .magazine-description {
        width: calc(60% - 21px);
        margin-left: map-get($grid-gutter-spacing, 'twenty-one');

        .title {
            &:hover {
                cursor: pointer;
            }
        }
    }

    .magazine-summary {
        font-size: $base-font-size;

        .label {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:hover {
            cursor: pointer;
        }
    }

    .magazine-actions {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');

        .btn {
            &:before {
                margin-right: 0;
            }

            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .magazines-headers {
        flex-direction: row;

        .btn {
            width: auto;

            &:not(:last-child) {
                margin-bottom: 0;
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}
</style>
